import { t as AitisalSdk } from "../../aitisal-sdk-B2mK3RTK.mjs";

//#region user/role/index.ts
async function createAitisalRole(createRole) {
	return AitisalSdk.getInstance().post("users/roles", createRole);
}
async function createBrandRole(brandUUID, createRole) {
	return AitisalSdk.getInstance().post(`users/brands/${brandUUID}/roles`, createRole);
}
async function updateRole(roleUUID, updateRole) {
	return AitisalSdk.getInstance().patch(`users/roles/${roleUUID}`, updateRole);
}
async function getRole(roleUUID) {
	return AitisalSdk.getInstance().get(`users/roles/${roleUUID}`);
}
async function getOwnerRole() {
	return AitisalSdk.getInstance().get(`users/roles/owner`);
}
async function browseRoles() {
	return AitisalSdk.getInstance().get(`users/roles`);
}
async function deleteRole(roleUUID) {
	return AitisalSdk.getInstance().delete(`users/roles/${roleUUID}`);
}

//#endregion
export { browseRoles, createAitisalRole, createBrandRole, deleteRole, getOwnerRole, getRole, updateRole };
//# sourceMappingURL=index.mjs.map